export enum MODAL_SIZES {
  lg = 'large',
  md = 'medium',
  sm = 'small',
}
